import moment from "moment-timezone";
import { GERAR_OCORRENCIA } from "@/utils/constants/typeAttendance";
import { isOccurrenceNapLotadaPayload } from "@/utils/constants/occurrenceServiceOptions";

/**
 * Monta o body da ocorrência para saveGenerateOs (correção de endereço ou NAP lotada).
 * @param {object} contract — formScheme da página
 * @param {string|number} serviceOptionId — id da opção de atendimento (idServiceOption)
 */
function createJsonOccurrence(contract, serviceOptionId) {
  const codeCity =
    contract.codeCity != null && typeof contract.codeCity === "object"
      ? String(contract.codeCity.value ?? "")
      : String(contract.codeCity ?? "");

  const addr = contract.occurrenceAddress || {};
  const idOpt = String(serviceOptionId ?? "");

  const base = {
    accredited: contract.accredited ?? "",
    numberPhone: String(contract.numberPhone ?? "").replace(/\D/g, ""),
    codeCity,
    contractNumber:
      contract.contractNumber !== "" && contract.contractNumber != null
        ? String(contract.contractNumber)
        : "0",
    typeAttendance: GERAR_OCORRENCIA,
    dateStartedAttendance: moment
      .tz(contract.dateStartedAttendance, "America/Sao_Paulo")
      .format("YYYY-MM-DD HH:mm"),
    dateFinishedAttendance: moment
      .tz(contract.dateFinishedAttendance, "America/Sao_Paulo")
      .format("YYYY-MM-DD HH:mm"),
  };

  if (isOccurrenceNapLotadaPayload(idOpt)) {
    return {
      ...base,
      osRequests: [
        {
          customerName: String(addr.customerName ?? "").trim(),
          napCustomer: String(contract.napCustomer ?? "").trim(),
          napInstallation: String(contract.napInstallation ?? "").trim(),
          idServiceOption: idOpt,
        },
      ],
    };
  }

  return {
    ...base,
    osRequests: [
      {
        customerName: String(addr.customerName ?? "").trim(),
        streetAddressOS: String(addr.streetAddressOS ?? "").trim(),
        numberAddressOS: String(addr.numberAddressOS ?? "").trim(),
        additionalInformationAddressOS: String(
          addr.additionalInformationAddressOS ?? "",
        ).trim(),
        neighborhoodAddressOS: String(addr.neighborhoodAddressOS ?? "").trim(),
        zipCodeAddressOS: String(addr.zipCodeAddressOS ?? "").replace(/\D/g, ""),
        streetProofOfAddress: String(addr.streetProofOfAddress ?? "").trim(),
        numberProofOfAddress: String(addr.numberProofOfAddress ?? "").trim(),
        additionalInformationProofOfAddress: String(
          addr.additionalInformationProofOfAddress ?? "",
        ).trim(),
        neighborhoodProofOfAddress: String(
          addr.neighborhoodProofOfAddress ?? "",
        ).trim(),
        zipCodeProofOfAddress: String(addr.zipCodeProofOfAddress ?? "").replace(
          /\D/g,
          "",
        ),
        napInstallation: String(contract.napInstallation ?? "").trim(),
        idServiceOption: idOpt,
      },
    ],
  };
}

export default createJsonOccurrence;
